export default "__VITE_ASSET__904de390__"